import { WorkspaceWindowDto } from '@mark43/cad-api';
import { makeObservable, observable } from 'mobx';
import { WorkspaceMap } from './workspace-map';
import { WorkspaceWindowActionDelegate } from './types';

type WorkspaceAlteredWindow = Omit<WorkspaceWindowDto, 'workspaceMapDto'> & {
    workspaceMap?: WorkspaceMap;
};

export class WorkspaceWindow implements WorkspaceAlteredWindow {
    id: WorkspaceWindowDto['id'];
    windowType: WorkspaceWindowDto['windowType'];
    workspaceId: WorkspaceWindowDto['workspaceId'];
    workspacePanels: WorkspaceWindowDto['workspacePanels'];
    isCadNext: WorkspaceWindowDto['isCadNext'];
    windowChildrenCreated?: WorkspaceWindowDto['windowChildrenCreated'];
    height: WorkspaceWindowDto['height'];
    width: WorkspaceWindowDto['width'];
    xcoordinate: WorkspaceWindowDto['xcoordinate'];
    ycoordinate: WorkspaceWindowDto['ycoordinate'];
    zindex: WorkspaceWindowDto['zindex'];

    @observable
    workspaceMap?: WorkspaceMap;
    private delegate: WorkspaceWindowActionDelegate;

    constructor({
        workspaceWindowDto,
        delegate,
    }: {
        workspaceWindowDto: WorkspaceWindowDto;
        delegate: WorkspaceWindowActionDelegate;
    }) {
        this.id = workspaceWindowDto.id;
        this.windowType = workspaceWindowDto.windowType;
        this.workspaceId = workspaceWindowDto.workspaceId;
        this.isCadNext = workspaceWindowDto.isCadNext;
        this.windowChildrenCreated = workspaceWindowDto.windowChildrenCreated;
        this.height = workspaceWindowDto.height;
        this.width = workspaceWindowDto.width;
        this.xcoordinate = workspaceWindowDto.xcoordinate;
        this.ycoordinate = workspaceWindowDto.ycoordinate;
        this.zindex = workspaceWindowDto.zindex;

        this.delegate = delegate;

        // TODO: initialize WorkspacePanel in WorkspaceWindow
        this.workspacePanels = workspaceWindowDto.workspacePanels;

        this.workspaceMap =
            this.windowType === 'MAP_V2'
                ? new WorkspaceMap({
                      workspaceWindowId: workspaceWindowDto.id,
                      workspaceMapDto: workspaceWindowDto.workspaceMapDto,
                      delegate: this.delegate,
                  })
                : undefined;

        makeObservable(this);
    }

    public getDto(): WorkspaceWindowDto {
        return {
            id: this.id,
            windowType: this.windowType,
            workspaceId: this.workspaceId,
            workspacePanels: this.workspacePanels,
            workspaceMapDto: this.workspaceMap?.getDto(),
            isCadNext: this.isCadNext,
            windowChildrenCreated: this.windowChildrenCreated,
            height: this.height,
            width: this.width,
            xcoordinate: this.xcoordinate,
            ycoordinate: this.ycoordinate,
            zindex: this.zindex,
        };
    }

    public updateWorkspaceWindow(workspaceWindow: WorkspaceWindowDto) {
        if (
            this.id !== workspaceWindow.id ||
            this.windowType != workspaceWindow.windowType ||
            this.workspaceId !== workspaceWindow.workspaceId
        ) {
            return;
        }
        this.height = workspaceWindow.height;
        this.isCadNext = workspaceWindow.isCadNext;
        this.width = workspaceWindow.width;
        this.windowChildrenCreated = workspaceWindow.windowChildrenCreated;
        this.workspacePanels = workspaceWindow.workspacePanels;
        this.xcoordinate = workspaceWindow.xcoordinate;
        this.ycoordinate = workspaceWindow.ycoordinate;
        this.zindex = workspaceWindow.zindex;
        if (workspaceWindow.workspaceMapDto) {
            if (this.workspaceMap) {
                this.workspaceMap.updateWorkspaceMap(workspaceWindow.workspaceMapDto);
            } else if (this.windowType === 'MAP_V2') {
                this.workspaceMap = new WorkspaceMap({
                    workspaceWindowId: workspaceWindow.id,
                    workspaceMapDto: workspaceWindow.workspaceMapDto,
                    delegate: this.delegate,
                });
            }
        }
    }

    public getWorkspaceMap() {
        return this.workspaceMap;
    }
}
